module.exports = __webpack_public_path__ + "static/susieyy-alt-0959f52e2936a917964306fa5523452b.png";